import { createJSONStorage, atomWithStorage } from "jotai/utils"
import { z } from "zod"

export const timeSpentSchema = z.object({
	tripsPerDay: z.object({
		from: z.coerce.number().min(0),
		to: z.coerce.number().min(0),
	}),
	timeAtLocation: z.object({
		from: z.coerce.number().min(0),
		to: z.coerce.number().min(0),
	}),
	timeInOffice: z.object({
		from: z.coerce.number().min(0),
		to: z.coerce.number().min(0),
	}),
})

export type TimeSpent = z.infer<typeof timeSpentSchema>

const storage = createJSONStorage<TimeSpent>(() => localStorage)

export const defaultTimeSpent: TimeSpent = {
	tripsPerDay: {
		from: 0,
		to: 0,
	},
	// TODO: set default value
	timeAtLocation: {
		from: 0,
		to: 0,
	},
	timeInOffice: {
		from: 0,
		to: 0,
	},
}

export const timeSpentDraftAtom = atomWithStorage<TimeSpent>(
	"miles:draft:time-spent",
	defaultTimeSpent,
	storage,
	{ getOnInit: true }
)
